import SheetTile from 'components/SheetTile';
import React from 'react';
import { Sheet } from 'records/Sheet';

type ModalGridOptionProps = {
  onOptionClick: VoidFunction;
  selected: boolean;
  sheet: Sheet;
};

const ModalGridOption: React.FC<ModalGridOptionProps> = ({
  onOptionClick,
  selected,
  sheet,
}: ModalGridOptionProps) => {
  return (
    <div className="primary-blue bold cursor-pointer" onClick={onOptionClick}>
      <SheetTile sheet={sheet} selected={selected} />
    </div>
  );
};

export default ModalGridOption;
